// /* eslint-disable */
const _CONFIG_ = require('_CONFIG_');
// eslint-disable-next-line camelcase
export default __webpack_public_path__ =  (_CONFIG_ && _CONFIG_.cdn) || '';
